import React, { useState, useRef } from 'react'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import en from 'react-phone-number-input/locale/en'
import { Box } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import flags from 'react-phone-number-input/flags'
import { getCountries } from 'react-phone-number-input'

const CustomCountrySelect = ({ value, onChange }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const buttonRef = useRef(null)

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleSelect = (countryCode) => {
    onChange(countryCode)
    handleClose()
  }

  const Icon = flags[value]
  return (
    <div>
      <Box ref={buttonRef} onClick={handleOpen} sx={style.menu}>
        <Box className="flag">
          <Icon />
        </Box>
        <span className="expand">
          <ExpandMoreIcon />
        </span>
      </Box>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}>
        {getCountries().map((countryCode) => (
          <MenuItem key={countryCode} value={countryCode} onClick={() => handleSelect(countryCode)}>
            {en[countryCode]}
          </MenuItem>
        ))}
      </Menu>
    </div>
  )
}

export default CustomCountrySelect

const style = {
  menu: {
    marginRight: 0.8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '1px',
    cursor: 'pointer',
    '.expand': {
      svg: {
        width: 20
      }
    },
    '.flag': {
      svg: {
        width: 30,
        marginRight: 0.3
      }
    }
  }
}
